import styled from 'styled-components'

export const DifmFallbackContainer = styled.section`
  display: grid;
  grid-template-columns: 24px 1fr;
  gap: 8px;
  padding: 12px 16px;
  border-radius: 4px;
  border: 1px solid #D4D4D6;
  background: #FFF;
`

export const MessageContainer = styled.section`
  display: flex;
  flex-direction: column;
`

export const Header = styled.h4`
  color: #282832;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  margin: 0 0 2px 0;
`

export const Message = styled.div`
  color: #282832;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`

export const LearnMoreButton = styled.button`
  color: #282832;
  display: flex;
  font-family: "Roboto", Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-decoration-line: underline;
  cursor: pointer;
  border: none;
  background: white;
  padding: 0;
`
